import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule,ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { ClearingHouseComponent } from './clearing-house.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ClearingHouseRoutingModule } from './clearing-house-routing.module';
@NgModule({
  declarations: [
    ClearingHouseComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgbModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    ClearingHouseRoutingModule
  ],
  providers: [ColumnChooserService,PageService,SortService,FilterService, ResizeService],
})
export class ClearingHouseModule { }
